export const generateSingleVideoSlug = (prefix: string, slug: string) =>
  `/${prefix}/${slug}`;
